// extracted by mini-css-extract-plugin
export default {"bigNumber":"_1vs9","tooltip":"QOkJ"};